import { render, staticRenderFns } from "./ShipmentAuthorizationRequest.vue?vue&type=template&id=ecf36b90&scoped=true"
import script from "./ShipmentAuthorizationRequest.vue?vue&type=script&lang=js"
export * from "./ShipmentAuthorizationRequest.vue?vue&type=script&lang=js"
import style0 from "./ShipmentAuthorizationRequest.vue?vue&type=style&index=0&id=ecf36b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf36b90",
  null
  
)

export default component.exports